import request from '@/utils/request';
import { stringify } from 'qs';


export async function checkWelfare (params: object) {
  return request(`/api/weChatServer/checkWelfare?${stringify(params)}`, {})
}

export async function getWelfare (params: object) {
  return request(`/api/weChatServer/getWelfare?${stringify(params)}`, {})
}
